import BaseComponent from "../../baseComponent.js";
import EditableRow from "./editableRow.jsx";

export default class Variable extends BaseComponent {
  render() {
    let output = this.props.variableModel;
    let fieldIds = Object.keys(this.props.variableModel.fields);
    let rows = [];

    for (let i = 0; i < this.props.numRows; i++) {
      let fieldId = fieldIds[i] || "";
      let value = fieldId != "" ? output.fields[fieldId].value : "";
      let formula = fieldId != "" ? output.fields[fieldId].formula : "";
      rows.push(<EditableRow
        type="OUTPUT"
        onClick={this.props.changeCurrentFormula}
        onChange={this.props.updateFormula}
        datasetId={output.datasetId}
        datasetRefId={output.datasetRef}
        fieldId={fieldId}
        color={output.color}
        value={value}
        formula={formula}
        key={i}
      />);
    }
    return (
      <div className="spreadsheet-output-dataset">
        <table ref="table">
          <tbody>
          {rows}
          </tbody>
        </table>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/analytic-studio/spreadsheet/variable.jsx